import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = "522281200243";
export const WHATSAPP_DISPLAY = "+52 228 120 0243";

export const api = axios.create({ baseURL: API });

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem("shintergy_admin_token", token);
    api.defaults.headers.common["X-Admin-Token"] = token;
  } else {
    localStorage.removeItem("shintergy_admin_token");
    delete api.defaults.headers.common["X-Admin-Token"];
  }
}

export function loadAdminToken() {
  const t = localStorage.getItem("shintergy_admin_token");
  if (t) api.defaults.headers.common["X-Admin-Token"] = t;
  return t;
}

export const formatMXN = (n) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 0,
  }).format(n || 0);

export function buildWhatsAppUrl(text) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function resolveImage(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
